import React, { useState, useEffect } from "react";

//import './styles.css';
import Toast from "../Toast";

export default function ActionNotifications({ arrayOfToasts, response }) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (response && Object.keys(response).length > 0) {
      console.log("response", response);

      let fetchNotifications = [];

      if (
        response?.success &&
        response?.data?.statusCode &&
        response?.success !== "Invalid Model"
      ) {
        let message = "";
        if (response.data.messeges?.length > 0) {
          message = response.data.messeges.join(" ");
        } else {
          message = response.data.data;
        }
        fetchNotifications.push({
          id: Date.now(),
          isMessageInGDStanding: true,
          message: message,
        });
      } else if (Array.isArray(response?.data?.messeges)) {
        fetchNotifications.push({
          id: Date.now(),
          isMessageInGDStanding: false,
          message: String(response.data.messeges),
        });
      } else if (response?.errors) {
        fetchNotifications.push({
          id: Date.now(),
          isMessageInGDStanding: false,
          message: String(response.errors),
        });
      } else {
        fetchNotifications.push({
          id: Date.now(),
          isMessageInGDStanding: false,
          message:
            "An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.",
        });
      }
      if (fetchNotifications?.length > 0) {
        setNotifications(fetchNotifications);
        console.log("fetchNotifications", fetchNotifications);
      }
    }
  }, [response]);

  useEffect(() => {
    if (arrayOfToasts?.length > 0) {
      const notify = arrayOfToasts.filter((x) => {
        return x !== undefined;
      });
      //const notify = arrayOfToasts.filter(x => x !== undefined).map(toast => ({
      //    ...toast,
      //    id: Date.now() // Unique ID
      //}));

      if (notify?.length > 0) {
        setNotifications((prev) => [...prev, ...notify]);
      }
    }
  }, [arrayOfToasts]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{ position: "relative", zIndex: 2000 }}
    >
      {notifications && (
        <div
          className="toast-box"
          style={{ position: "fixed", top: "15px", right: "30px" }}
        >
          {notifications.map((toast, i) => {
            const color = toast.isMessageInGDStanding ? "greenBG" : "redBG";

            return (
              <Toast key={toast.id} message={toast.message} color={color} />
            );
          })}
        </div>
      )}
    </div>
  );
}
